import { Toast } from "primereact/toast";
import AppBreadcrumb from "../../components/CustomeBreadcrumb/AppBreadcrumb";
import { useEffect, useRef, useState } from "react";
import Loader from "../../components/Loadeer/Loader";
import { ErrorMessage, FieldArray, Form, Formik } from "formik";
import { Divider } from "primereact/divider";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import { RadioButton } from "primereact/radiobutton";
import axiosInstance from "../../config/axiosInstance";
import { validateBooking } from "../../config/Validate";
import { Dropdown } from "primereact/dropdown";
import { getAllDetails, postAllData } from "../../service/ProductService";
import {
  ADD_BOOKING,
  GET_BOOKING_SLOTS_LIST,
  GET_CROP_LIST,
  GET_FARM_LIST,
  GET_FARMER_LIST,
  GET_SERVICE_LIST,
  GET_SERVICEITEM_LIST,
} from "../../config/ApiConstant";
import { Calendar } from "primereact/calendar";
import { APP_BASE_URL } from "../../appconfig/Settings";
import { MultiSelect } from "primereact/multiselect";
import { InputText } from "primereact/inputtext";

const initialValues = {
  user_id: "",
  service_id: "",
  booking_date: null,
  timePeriod: "",
  time_slot_id: null,
  farm_data: [
    {
      farm_id: "",
      crop_data: [
        {
          crop_id: "",
          variety_name: "",
          area: "",
          sowing_date: "",
          spray_for_problem: "",
          service_items_spray: [],
          service_items_soil: [],
          service_items_additional: [],
        },
      ],
    },
  ],
  payment_method: "Cash",
  is_advance: false,
  is_remaining: false,
};

const AddBooking = () => {
  //   toast ref
  const toast = useRef<any>(null);
  //   navigate
  const navigate = useNavigate();

  //   loader
  const [pageLoader, setPageLoader] = useState<boolean>(false);

  //   store data
  const [farmerList, setFarmerList] = useState<any>([]);
  const [serviceList, setServiceList] = useState<any>([]);
  const [farmsByFarmer, setFarmsByFarmer] = useState([]);
  const [cropsByFarm, setCropsByFarm] = useState([]);
  const [serviceItem, setServiceItem] = useState([]);

  const [bookingTimeSlot, setBookingTimeSlot] = useState<boolean>(false);
  const [timePeriodOptions] = useState([
    { label: "Morning", value: "morning" },
    { label: "Afternoon", value: "afternoon" },
    { label: "Evening", value: "evening" },
  ]);
  const [timeSlotOptions, setTimeSlotOptions] = useState<any>([]);

  useEffect(() => {
    getFarmerList();
    getServiceList();
    getCropList();
  }, []);

  //   get farmer list
  const getFarmerList = async () => {
    try {
      setPageLoader(true);
      const response = await getAllDetails(GET_FARMER_LIST + `?type=dropdown`);
      const updatedFarmer = response.map((farmer: any) => ({
        label: farmer.name,
        value: Number(farmer.id),
      }));
      setFarmerList(updatedFarmer || []);
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error?.response?.data?.message,
      });
    } finally {
      setPageLoader(false);
    }
  };

  // api for get farm list from farmer id
  const getFarmList = async (farmerId: any) => {
    try {
      setPageLoader(true);
      const response = await getAllDetails(
        GET_FARM_LIST + `?user_id=${farmerId}`
      );
      const updatedFarm = response.map((farm: any) => ({
        label: farm.farm_name,
        value: farm.id,
      }));
      setFarmsByFarmer(updatedFarm || []);
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error?.response?.data?.message,
      });
    } finally {
      setPageLoader(false);
    }
  };

  //   get service item api
  const getServiceItemType = async (serviceId: any) => {
    try {
      setPageLoader(true);
      const response = await getAllDetails(
        GET_SERVICEITEM_LIST +
          `?type=${serviceId === 1 ? "spray" : "soil&type=additional"}`
      );
      const updatedSerItem = response.map((item: any) => ({
        label: item.item_name,
        value: item.id,
        type: item.item_type,
      }));
      setServiceItem(updatedSerItem || []);
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error?.response?.data?.message,
      });
    } finally {
      setPageLoader(false);
    }
  };

  //   get crop list from selected farm
  const getCropList = async () => {
    try {
      setPageLoader(true);
      const response = await getAllDetails(GET_CROP_LIST);
      const updatedCrops = response.map((crop: any) => ({
        label: crop.crop_name,
        value: crop.id,
      }));
      setCropsByFarm(updatedCrops || []);
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error?.response?.data?.message,
      });
    } finally {
      setPageLoader(false);
    }
  };

  //   get service list
  const getServiceList = async () => {
    try {
      setPageLoader(true);
      const response = await axiosInstance(APP_BASE_URL + GET_SERVICE_LIST);
      const res = response?.data;

      // set booking time slot status
      setBookingTimeSlot(res.booking_time_slot === "true");

      const updatedService = res.data.map((service: any) => ({
        label: service.service_name,
        value: service.id,
      }));
      setServiceList(updatedService || []);
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error?.response?.data?.message,
      });
    } finally {
      setPageLoader(false);
    }
  };

  // get available time slots (when booking_time_slot is true)
  const getAvailableTimeSlots = async (timePeriod: string) => {
    try {
      setPageLoader(true);
      const response = await getAllDetails(
        `${GET_BOOKING_SLOTS_LIST}?type="dropdown"&slot=${timePeriod}`
      );

      //   formate time slot from response
      const formattedSlots = response.map((slot: any) => ({
        label: `${slot.start_time.slice(0, 5)} - ${slot.end_time.slice(0, 5)}`,
        value: slot.id,
      }));

      setTimeSlotOptions(formattedSlots);
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error?.response?.data?.message,
      });
    } finally {
      setPageLoader(false);
    }
  };

  // Submit handler
  const handleSubmit = async (values: any, { resetForm }: any) => {
    const { timePeriod, ...filteredValues } = values;

    // Build final payload
    const finalPayload = {
      ...filteredValues,
      farm_data: filteredValues.farm_data.map((farm: any) => ({
        ...farm,
        crop_data: farm.crop_data.map((crop: any) => {
          // merge service items
          const service_items = [
            ...(crop.service_items_spray || []),
            ...(crop.service_items_soil || []),
            ...(crop.service_items_additional || []),
          ].map((id) => ({ id }));

          // remove unwanted keys
          const {
            service_items_spray,
            service_items_soil,
            service_items_additional,
            ...rest
          } = crop;

          return { ...rest, service_items };
        }),
      })),
    };
    
    try {
      const response = await postAllData(ADD_BOOKING, finalPayload);

      if (response) {
        toast.current?.show({
          severity: "success",
          summary: "Success",
          detail: response.message,
        });
        resetForm();
        setTimeout(() => {
          navigate("/booking");
        }, 500);
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error?.response?.data?.message,
      });
    }
  };

  return (
    <>
      {/* Breadcrumb */}
      <AppBreadcrumb
        currentMenu="Bookings"
        pageName={"Add Booking"}
        pageTitle={"Add Booking"}
        goToPage={true}
      />
      <div className="grid crud-demo">
        <div className="col-12">
          <div className="card">
            <Toast ref={toast} />

            {pageLoader && <Loader />}

            <Formik
              initialValues={initialValues}
              enableReinitialize
              validate={(values) => validateBooking(values, bookingTimeSlot)}
              onSubmit={handleSubmit}
            >
              {({
                values,
                errors,
                touched,
                handleBlur,
                isSubmitting,
                setFieldValue,
              }) => (
                <Form className="p-fluid">
                  {/* user dropdown */}
                  <div className="grid formgrid">
                    {/* select farmer */}
                    <div className="field col-12 md:col-4">
                      <label htmlFor="user_id">Select Farmer *</label>
                      <Dropdown
                        id="user_id"
                        value={values.user_id}
                        options={farmerList}
                        onChange={(e) => {
                          setFieldValue("user_id", e.value);
                          getFarmList(e.value);
                        }}
                        onBlur={handleBlur}
                        placeholder="Select Farmer"
                        className={
                          touched.user_id && errors.user_id ? "p-invalid" : ""
                        }
                      />
                      <small className="p-error">
                        <ErrorMessage name="user_id" />
                      </small>
                    </div>

                    {/* select booking date */}
                    <div className="field col-12 md:col-4">
                      <label htmlFor="service_id">Select Service *</label>
                      <Dropdown
                        id="service_id"
                        value={values.service_id}
                        options={serviceList}
                        onChange={(e) => {
                          setFieldValue("service_id", e.value);
                          getServiceItemType(e.value);
                        }}
                        onBlur={handleBlur}
                        placeholder="Select Service"
                        className={
                          touched.service_id && errors.service_id
                            ? "p-invalid"
                            : ""
                        }
                      />
                      <small className="p-error">
                        <ErrorMessage name="service_id" />
                      </small>
                    </div>

                    {/* select booking date */}
                    <div className="field col-12 md:col-4">
                      <label htmlFor="booking_date">Select Date *</label>
                      <Calendar
                        id="booking_date"
                        value={values.booking_date}
                        onChange={(e: any) =>
                          setFieldValue("booking_date", e.value)
                        }
                        onBlur={handleBlur}
                        showIcon
                        dateFormat="dd/mm/yy"
                        minDate={new Date()}
                        placeholder="Select Date"
                        className={
                          touched.booking_date && errors.booking_date
                            ? "p-invalid"
                            : ""
                        }
                      />
                      <small className="p-error">
                        <ErrorMessage name="booking_date" />
                      </small>
                    </div>

                    {bookingTimeSlot && (
                      <div className="field col-12 md:col-4">
                        <label htmlFor="timePeriod">Select Time Period *</label>
                        <Dropdown
                          id="timePeriod"
                          value={values.timePeriod}
                          options={timePeriodOptions}
                          onChange={(e) => {
                            setFieldValue("timePeriod", e.value);
                            getAvailableTimeSlots(e.value);
                          }}
                          placeholder="Select Time Period"
                          className={
                            touched.timePeriod && errors.timePeriod
                              ? "p-invalid"
                              : ""
                          }
                        />
                        <small className="p-error">
                          <ErrorMessage name="timePeriod" />
                        </small>

                        {/* Show Time Slot radio buttons if available */}
                        {bookingTimeSlot && timeSlotOptions.length > 0 && (
                          <div className="field pt-1 col-12 px-0">
                            <div className="flex flex-wrap gap-3 mt-2">
                              {timeSlotOptions.map(
                                (slot: any, index: number) => (
                                  <div
                                    key={index}
                                    className="flex align-items-center"
                                  >
                                    <RadioButton
                                      inputId={slot.value}
                                      name="time_slot_id"
                                      value={slot.value}
                                      onChange={(e) =>
                                        setFieldValue("time_slot_id", e.value)
                                      }
                                      checked={
                                        values.time_slot_id === slot.value
                                      }
                                    />
                                    <label
                                      htmlFor={slot.value}
                                      className="ml-2"
                                    >
                                      {slot.label}
                                    </label>
                                  </div>
                                )
                              )}
                            </div>
                            <small className="p-error">
                              <ErrorMessage name="time_slot_id" />
                            </small>
                          </div>
                        )}
                      </div>
                    )}

                    {/* Farm + Crop dynamic fields */}
                    <div className="field col-12">
                      <FieldArray name="farm_data">
                        {({ push, remove }) => (
                          <>
                            <div className="mt-4">
                              {values.farm_data.map(
                                (farm: any, farmIndex: any) => (
                                  <>
                                    <div className="field">
                                      <div key={farmIndex}>
                                        <div className="flex mb-3 align-items-center justify-content-between gap-2">
                                          <h6 className="mb-0">
                                            Farm {farmIndex + 1}
                                          </h6>
                                          {values.farm_data.length !== 1 && (
                                            <Button
                                              icon="pi pi-trash"
                                              tooltip="Remove Farm"
                                              tooltipOptions={{
                                                position: "top",
                                              }}
                                              className="p-button-danger text-sm"
                                              onClick={() => {
                                                if (values.farm_data.length > 1)
                                                  remove(farmIndex);
                                              }}
                                            />
                                          )}
                                        </div>
                                        {/* FARM SELECT */}
                                        <div className="field mb-3 md:col-3 col-12 px-0">
                                          <label>Select Farm *</label>
                                          <Dropdown
                                            id={`farm_data[${farmIndex}].farm_id`}
                                            value={farm.farm_id}
                                            options={farmsByFarmer}
                                            optionLabel="label"
                                            optionValue="value"
                                            onChange={(e) => {
                                              setFieldValue(
                                                `farm_data[${farmIndex}].farm_id`,
                                                e.value
                                              );
                                            }}
                                            placeholder="Select Farm"
                                          />
                                          <small className="p-error">
                                            <ErrorMessage
                                              name={`farm_data[${farmIndex}].farm_id`}
                                            />
                                          </small>
                                        </div>

                                        <FieldArray
                                          name={`farm_data[${farmIndex}].crop_data`}
                                        >
                                          {({
                                            push: addCrop,
                                            remove: removeCrop,
                                          }) => (
                                            <>
                                              {farm.crop_data?.map(
                                                (crop: any, cropIndex: any) => (
                                                  <div
                                                    key={cropIndex}
                                                    className="mb-2"
                                                  >
                                                    <div className="flex mb-3 align-items-center justify-content-between gap-2">
                                                      <h6 className="mb-0">
                                                        Crop {cropIndex + 1}
                                                      </h6>
                                                      {farm.crop_data.length !==
                                                        1 && (
                                                        <Button
                                                          icon="pi pi-trash"
                                                          tooltip="Remove Crop"
                                                          tooltipOptions={{
                                                            position: "top",
                                                          }}
                                                          className="p-button-danger text-sm"
                                                          onClick={() => {
                                                            if (
                                                              farm.crop_data
                                                                .length > 1
                                                            )
                                                              removeCrop(
                                                                cropIndex
                                                              );
                                                          }}
                                                        />
                                                      )}
                                                    </div>
                                                    <div>
                                                      <div className="formgrid grid">
                                                        {Number(
                                                          values.service_id
                                                        ) !== 2 && (
                                                          <>
                                                            <div className="field md:col-3 col-12">
                                                              <label>
                                                                Select Crop*
                                                              </label>
                                                              <Dropdown
                                                                value={
                                                                  crop.crop_id
                                                                }
                                                                options={
                                                                  cropsByFarm
                                                                }
                                                                optionLabel="label"
                                                                optionValue="value"
                                                                onChange={(e) =>
                                                                  setFieldValue(
                                                                    `farm_data[${farmIndex}].crop_data[${cropIndex}].crop_id`,
                                                                    e.value
                                                                  )
                                                                }
                                                                placeholder="Select Crop"
                                                              />
                                                              <small className="p-error">
                                                                <ErrorMessage
                                                                  name={`farm_data[${farmIndex}].crop_data[${cropIndex}].crop_id`}
                                                                />
                                                              </small>
                                                            </div>

                                                            <div className="field md:col-3 col-12">
                                                              <label>
                                                                Variety Name*
                                                              </label>
                                                              <InputText
                                                                placeholder="Variety Name"
                                                                value={
                                                                  crop.variety_name
                                                                }
                                                                onChange={(e) =>
                                                                  setFieldValue(
                                                                    `farm_data[${farmIndex}].crop_data[${cropIndex}].variety_name`,
                                                                    e.target
                                                                      .value
                                                                  )
                                                                }
                                                              />
                                                              <small className="p-error">
                                                                <ErrorMessage
                                                                  name={`farm_data[${farmIndex}].crop_data[${cropIndex}].variety_name`}
                                                                />
                                                              </small>
                                                            </div>

                                                            <div className="field md:col-3 col-12">
                                                              <label>
                                                                Area*
                                                              </label>
                                                              <InputText
                                                                placeholder="Area"
                                                                value={
                                                                  crop.area
                                                                }
                                                                onChange={(e) =>
                                                                  setFieldValue(
                                                                    `farm_data[${farmIndex}].crop_data[${cropIndex}].area`,
                                                                    e.target
                                                                      .value
                                                                  )
                                                                }
                                                              />
                                                              <small className="p-error">
                                                                <ErrorMessage
                                                                  name={`farm_data[${farmIndex}].crop_data[${cropIndex}].area`}
                                                                />
                                                              </small>
                                                            </div>

                                                            <div className="field md:col-3 col-12">
                                                              <label>
                                                                Crop Age*
                                                              </label>
                                                              <InputText
                                                                placeholder="Crop Age (Sowing Date)"
                                                                value={
                                                                  crop.sowing_date
                                                                }
                                                                onChange={(e) =>
                                                                  setFieldValue(
                                                                    `farm_data[${farmIndex}].crop_data[${cropIndex}].sowing_date`,
                                                                    e.target
                                                                      .value
                                                                  )
                                                                }
                                                              />
                                                              <small className="p-error">
                                                                <ErrorMessage
                                                                  name={`farm_data[${farmIndex}].crop_data[${cropIndex}].sowing_date`}
                                                                />
                                                              </small>
                                                            </div>

                                                            <div className="field md:col-3 col-12">
                                                              <label>
                                                                Spray For
                                                                Problem*
                                                              </label>
                                                              <InputText
                                                                placeholder="Spray For Problem"
                                                                value={
                                                                  crop.spray_for_problem
                                                                }
                                                                onChange={(e) =>
                                                                  setFieldValue(
                                                                    `farm_data[${farmIndex}].crop_data[${cropIndex}].spray_for_problem`,
                                                                    e.target
                                                                      .value
                                                                  )
                                                                }
                                                              />
                                                              <small className="p-error">
                                                                <ErrorMessage
                                                                  name={`farm_data[${farmIndex}].crop_data[${cropIndex}].spray_for_problem`}
                                                                />
                                                              </small>
                                                            </div>
                                                          </>
                                                        )}
                                                        {Number(
                                                          values.service_id
                                                        ) === 1 && (
                                                          <div className="field md:col-3 col-12">
                                                            <label>
                                                              Select Spray Type
                                                              *
                                                            </label>
                                                            <MultiSelect
                                                              value={
                                                                crop.service_items_spray
                                                              }
                                                              options={serviceItem.filter(
                                                                (item: any) =>
                                                                  item.label
                                                                    .toLowerCase()
                                                                    .includes(
                                                                      "spray"
                                                                    )
                                                              )}
                                                              onChange={(e) =>
                                                                setFieldValue(
                                                                  `farm_data[${farmIndex}].crop_data[${cropIndex}].service_items_spray`,
                                                                  e.value
                                                                )
                                                              }
                                                              optionLabel="label"
                                                              optionValue="value"
                                                              placeholder="Select Spray Type"
                                                              display="chip"
                                                            />
                                                            <small className="p-error">
                                                              <ErrorMessage
                                                                name={`farm_data[${farmIndex}].crop_data[${cropIndex}].service_items_spray`}
                                                              />
                                                            </small>
                                                          </div>
                                                        )}

                                                        {Number(
                                                          values.service_id
                                                        ) === 2 && (
                                                          <>
                                                            {/* Soil Test MultiSelect */}
                                                            <div className="field md:col-3 col-12">
                                                              <label>
                                                                Select Soil Test
                                                                *
                                                              </label>
                                                              <MultiSelect
                                                                value={
                                                                  crop.service_items_soil
                                                                }
                                                                options={serviceItem.filter(
                                                                  (item: any) =>
                                                                    item.type ===
                                                                    "Soil"
                                                                )}
                                                                onChange={(e) =>
                                                                  setFieldValue(
                                                                    `farm_data[${farmIndex}].crop_data[${cropIndex}].service_items_soil`,
                                                                    e.value
                                                                  )
                                                                }
                                                                optionLabel="label"
                                                                optionValue="value"
                                                                placeholder="Select Soil Test"
                                                                display="chip"
                                                              />
                                                              <small className="p-error">
                                                                <ErrorMessage
                                                                  name={`farm_data[${farmIndex}].crop_data[${cropIndex}].service_items_soil`}
                                                                />
                                                              </small>
                                                            </div>

                                                            {/* Additional Test MultiSelect */}
                                                            <div className="field md:col-3 col-12">
                                                              <label>
                                                                Select
                                                                Additional Test
                                                                *
                                                              </label>
                                                              <MultiSelect
                                                                value={
                                                                  crop.service_items_additional
                                                                }
                                                                options={serviceItem.filter(
                                                                  (item: any) =>
                                                                    item.type ===
                                                                    "Additional"
                                                                )}
                                                                onChange={(e) =>
                                                                  setFieldValue(
                                                                    `farm_data[${farmIndex}].crop_data[${cropIndex}].service_items_additional`,
                                                                    e.value
                                                                  )
                                                                }
                                                                optionLabel="label"
                                                                optionValue="value"
                                                                placeholder="Select Additional Test"
                                                                display="chip"
                                                              />
                                                              <small className="p-error">
                                                                <ErrorMessage
                                                                  name={`farm_data[${farmIndex}].crop_data[${cropIndex}].service_items_additional`}
                                                                />
                                                              </small>
                                                            </div>
                                                          </>
                                                        )}
                                                      </div>
                                                    </div>
                                                  </div>
                                                )
                                              )}
                                              <Button
                                                icon="pi pi-plus"
                                                label="Add Crop"
                                                className="mr-2 w-fit inline"
                                                onClick={() =>
                                                  addCrop({
                                                    crop_id: "",
                                                    variety_name: "",
                                                    area: "",
                                                    sowing_date: "",
                                                    spray_for_problem: "",
                                                    service_items: [],
                                                  })
                                                }
                                              />
                                            </>
                                          )}
                                        </FieldArray>
                                      </div>
                                    </div>
                                    <Divider
                                      className="mb-3"
                                      style={{ color: "lightgray" }}
                                    />
                                  </>
                                )
                              )}
                            </div>
                            <Button
                              icon="pi pi-plus"
                              label="Add Farm"
                              className="mt-3 w-fit"
                              onClick={() =>
                                push({
                                  farm_id: "",
                                  crop_data: [
                                    {
                                      crop_id: "",
                                      variety_name: "",
                                      area: "",
                                      sowing_date: "",
                                      spray_for_problem: "",
                                      service_items: [],
                                    },
                                  ],
                                })
                              }
                            />
                          </>
                        )}
                      </FieldArray>
                    </div>
                  </div>

                  <div className="flex gap-2 mt-4 justify-content-end">
                    <Button
                      label="Cancel"
                      icon="pi pi-times"
                      className="p-button-secondary w-fit"
                      onClick={() => navigate("/booking")}
                    />
                    <Button
                      label="Save Booking"
                      icon="pi pi-check"
                      className="w-fit"
                      type="submit"
                      loading={isSubmitting}
                      disabled={isSubmitting}
                      autoFocus
                    />
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddBooking;
